<template>
  <v-dialog
    v-model="dialogGDPR"
    max-width="1000px"
    transition="dialog-transition"
    v-if="dialogGDPR"
    persistent
  >
    <v-card class="no__padding">
      <v-card-title class="pa-0 justify-center" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
        <h2>Souhlas s GDPR</h2>
      </v-card-title>
      <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
        <v-form v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <p>Vaše osobní údaje zpracováváme v souladu s nařízením Evropského parlamentu a Rady (EU) č. 2016/679, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů, tzv. „GDPR“.</p>

              <p>Bližší informace o zpracování jsou uvedeny v informačním memorandu o ochraně a zpracování osobních údajů, uveřejněném na webových stránkách společnosti Comfort Commodity a.s. (<a href="https://www.comfort-commodity.cz/ochrana-osobnich-udaju" target="_blank">https://www.comfort-commodity.cz/ochrana-osobnich-udaju</a>).</p>

            </v-flex>
            <v-flex xs12>
              <p class="text-xs-center mt-3 mb-0">
                <v-btn depressed dark color="orange" class="ma-0 bold" @click="gdprAccept">Souhlasím s podmínkami</v-btn>
              </p>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogGDPR: false,
      valid: false
    }
  },
  props: {
    value: Boolean
  },
  mounted: function() {
    if (this.value) {
      this.dialogGDPR = true;
    }
  },
  methods: {
    gdprAccept () {
      this.dialogGDPR = false;
      window.API.post("uzivatel/gdpr").then(function(body) {
        this.$emit("value", true);
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>
